import {
  isAccountantRole,
  isAdminContourRole,
  isBusinessRole,
  isBusinessUserRole,
  normalizeAuthRole
} from './auth-roles';

export function getPostAuthRoute(role?: string | null, businessStatus?: string | null): string[] | null {
  const normalizedRole = normalizeAuthRole(role);
  const normalizedBusinessStatus = (businessStatus ?? '').toUpperCase();

  if (isAccountantRole(normalizedRole)) {
    return ['/accounting/invoices'];
  }

  if (isAdminContourRole(normalizedRole)) {
    return ['/admin/dashboard'];
  }

  if (isBusinessRole(normalizedRole)) {
    if (normalizedBusinessStatus === 'NO_DATA') {
      return ['/registration'];
    }

    return ['/businesses'];
  }

  if (isBusinessUserRole(normalizedRole)) {
    return ['/businesses'];
  }

  return null;
}

/**
 * BE-1489: первые сегменты адресов, открытых без входа (маршруты без гардов в app.routes):
 * вход, регистрация, сброс пароля, приглашение. Сверяется с картой маршрутов спекой.
 * Корень — тоже: по ссылкам из писем вида `/?reset_token=…` токены разбирает именно он.
 */
const PUBLIC_FIRST_SEGMENTS: ReadonlySet<string> = new Set([
  '',
  'auth',
  'register',
  'reset-password',
  'join',
  'client-registration',
  'registration-after-init',
]);

/**
 * Открыт ли адрес без входа. Сравнивается первый сегмент целиком: `/registration` закрыт
 * гардом, `/registration-after-init` — нет.
 */
export function isPublicPath(path: string): boolean {
  const firstSegment = pathOnly(path).split('/').find((segment) => segment !== '') ?? '';
  return PUBLIC_FIRST_SEGMENTS.has(firstSegment);
}

/** Адрес без query и фрагмента: `/a/b?x=1#y` → `/a/b`. */
export function pathOnly(url: string): string {
  return url.split(/[?#]/)[0];
}
